import { Paragraph, TextRun } from "docx";
import ConvertToString from "../Converter";
import generateLvTableRow from "./generateLvTableRow";
import { DRUCKPFAHL } from "../../constants";

export default function generateConstructionSiteSetupRow(lvData, positionNumber) {
  const textRuns = [
    new TextRun({
      text: "Probebelastungen",
      bold: true,
    }),
    new TextRun({
      text: "Probebelastungen nach " + lvData.testSequenceTypeHumanReadableShort,
      break: 1,
    }),
  ];

  if (lvData.testSequenceTypeIsExpert) {
    textRuns.push(
      new TextRun({
        text: "Zur Qualitätssicherung soll lediglich die Gebrauchstauglichkeit an Bauwerkspfählen bestätigt werden. Hierzu kann projektbezogen durch den AG oder Geotechnischen Sachverständigen ein Prüfablauf festgelegt werden, mit z.B. weniger Laststufen, nur 2 Lastzyklen, abgeminderter Prüflast (PP ≥ Fd) und verkürzten Beobachtungszeiten.",
        break: 2,
        italics: true,
        color: "6E6E6E",
      })
    );
  }

  textRuns.push(
    new TextRun({
      text: "Prüflast: " + lvData.testLoadNoDecimals + " kN",
      break: 2,
    }),
    new TextRun({
      text: "(ggf. ist in Abhängigkeit der Prüflast für die beprobten Mikropfähle ein größeres Stahltragglied zu kalkulieren)",
      break: 1,
    })
  );

  if (lvData.testSequenceTypeIsDIN && lvData.loadDirection === DRUCKPFAHL) {
    textRuns.push(
      new TextRun({
        text: "I.d.R. wird auch bei Druckpfählen die Tragfähigkeit über eine Zugprüfung nachgewiesen. Sollte zwingend eine Druckprüfung gewünscht sein, so ist dies entsprechend auszuschreiben.",
        break: 2,
        italics: true,
        color: "6E6E6E",
      })
    );
  }

  textRuns.push(
    new TextRun({
      text: "Einschließlich liefern der Spanneinrichtung und Durchführung aller Nebenarbeiten. Sämtliche Aufwendungen hierfür sind im Einheitspreis einzukalkulieren. Das Protokollieren der Messergebnisse (inkl. Prüfbericht) wird nicht gesondert vergütet und ist einzurechnen",
      break: 2,
    })
  );

  const descriptionParagraph = new Paragraph({
    children: textRuns,
  });

  return generateLvTableRow(
    positionNumber,
    descriptionParagraph,
    ConvertToString(lvData.numberOfTests),
    "Stk"
  );
}
